// hooks/shared/useGlobalUser.ts

import { authApi } from "@features/auth";
import { UserProfile } from "@features/auth/types";
import { coreApi } from "@features/core/api";
import { useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";



const CACHED_USER_PERMISSION_KEY = "cached_user_permissions";

export const useGlobalUserPermission = () => {
  const queryKey = QueryKeyFactory.module.onboarding.userRolePermissionAccess();
  const remoteUtilityId = useRemoteUtilityId();

  return useSmartQuery<any>(
    queryKey,
    async () => {
      // Check localStorage cache — permissions are written on login
      const stored = localStorage.getItem(CACHED_USER_PERMISSION_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
      // Fallback: only hit API if localStorage is genuinely missing
      const userRoles = await coreApi.getUserRolePermissionAccess(remoteUtilityId);
      localStorage.setItem(CACHED_USER_PERMISSION_KEY, JSON.stringify(userRoles));
      return userRoles;
    },
    {
      staleTime: Infinity, // Never re-fetch permissions during the session
      gcTime: Infinity,    // Keep in cache indefinitely
    },
  );
};

